// extracted by mini-css-extract-plugin
module.exports = {"modal":"ImageEditorModal_modal__2BqEW"};